import { render, staticRenderFns } from "./ScreenTips.vue?vue&type=template&id=57540442&scoped=true"
import script from "./ScreenTips.vue?vue&type=script&lang=js"
export * from "./ScreenTips.vue?vue&type=script&lang=js"
import style0 from "./ScreenTips.vue?vue&type=style&index=0&id=57540442&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57540442",
  null
  
)

export default component.exports